/* global bootstrap */
import { nextTick, onBeforeUnmount, onMounted } from 'vue';
import Sortable from 'sortablejs-make';

// Drag & drop reordering of a v-for list. `listRef` is the element whose direct
// children are the v-for items, `items` the array they render, and `handle` the
// selector of the grip inside each item (keep it unique when lists are nested).
// `onMove(item, newIndex)` is called after the array has been reordered.
export default function useSortableList(listRef, items, handle, onMove) {
  let sortable = null;

  // Bootstrap never sees the mouse leave a dragged handle, so its tooltip would stay on screen.
  const hideTooltips = () => {
    listRef.value?.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((element) => {
      bootstrap.Tooltip.getInstance(element)?.hide();
    });
  };

  onMounted(() => {
    sortable = new Sortable(listRef.value, {
      handle,
      animation: 150,
      ghostClass: 'opacity-50',
      onStart: hideTooltips,
      onEnd: (event) => {
        hideTooltips();
        if (event.oldIndex === event.newIndex) return;

        // Let Vue own the DOM: undo Sortable's move, then reorder the data.
        const children = event.from.children;
        const reference = event.oldIndex < event.newIndex ? children[event.oldIndex] : children[event.oldIndex].nextSibling;
        event.from.insertBefore(event.item, reference);
        const [item] = items.value.splice(event.oldIndex, 1);
        items.value.splice(event.newIndex, 0, item);
        nextTick(hideTooltips);
        onMove(item, event.newIndex);
      }
    });
  });

  onBeforeUnmount(() => {
    sortable?.destroy();
  });
}
